export default __webpack_public_path__ + "static/2133-9eba83d1abef4bc5ee8efa935b8adcca.gif";